/**
 * Faculty Index
 *
 * @author Space-Time Inc.
 * @version 2024-07-20
 */

document.addEventListener('DOMContentLoaded', () => {
	for (const a of Array.from(document.querySelectorAll('.faculty-index-list a'))) {
		const pos = a.href.indexOf('#');
		if (pos === -1) continue;
		if (!document.querySelector(a.href.substring(pos))) {
			a.classList.add('disabled');
		}
	}

	const cv = document.querySelector('.faculty-index input');
	const ec = document.querySelector('.entry-content');
	if (cv && ec) {
		cv.addEventListener('click', () => {
			ec.classList.toggle('card');
			ec.classList.toggle('all');
		});
	}
});
